import type { RouteObject } from "react-router";
import PolicyReplacementProgressPage from "work/policy-replacements/_views/policy-replacement-progress-page";
import ReplacePolicyPage from "work/policy-replacements/_views/replace-policy-page";
import { POLICY_REPLACEMENTS_ROOT } from "work/policy-replacements/policy-replacement-routes";

/**
 * The policy replacement pages, as the application's router mounts them (#6257). The progress page's
 * address is what the requester's notifications link to (#6256).
 */
export const policyReplacementRouteTree: RouteObject = {
  path: POLICY_REPLACEMENTS_ROOT,
  children: [
    { path: "new", element: <ReplacePolicyPage /> },
    { path: ":policyReplacementId", element: <PolicyReplacementProgressPage /> },
  ],
};
